import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { TextField } from '@mui/material'

import Dialog from '../common/dialog'
import { textFieldWhiteBg } from '../../theme/custom-styles'

export const CreatePocketModal = ({
  isLoading,
  handleCreatePocket,
  handleOpenStateOfModal
}: {
  isLoading: boolean
  handleOpenStateOfModal: (openState: boolean) => void
  handleCreatePocket: (pocketNameData: string) => void
}) => {
  const location = useLocation()
  const { t } = useTranslation(['pockets-management'])

  const [pocketNameData, setPocketNameData] = useState('')
  const [errors, setErrors] = useState<{ pocketName: string } | null>(null)

  const handleSubmitPocketDataCreation = () => {
    if (isLoading) return

    setErrors(null)

    if (!pocketNameData) {
      setErrors({ pocketName: t('createPocketModal.errors.pocketName') })
      return
    }

    handleCreatePocket(pocketNameData)
  }

  return (
    <Dialog
      hideActionsButtons={!location.pathname.includes('customer-company-details')}
      dialogIsLoading={isLoading}
      dialogTitle={t('createPocketModal.title')}
      handleDialogAction={handleSubmitPocketDataCreation}
      actionButtonText={t('createPocketModal.actionButtonText')}
      handleDialogOpenState={(openState: boolean) => {
        if (isLoading) return

        handleOpenStateOfModal(openState)

        if (openState === false) {
          setErrors(null)
          setPocketNameData('')
        }
      }}
    >
      {location.pathname.includes('customer-company-details') ? (
        <TextField
          fullWidth
          variant="standard"
          sx={textFieldWhiteBg}
          value={pocketNameData || ''}
          error={!!errors?.pocketName}
          helperText={errors?.pocketName}
          label={t('createPocketModal.textFieldLabel')}
          onChange={(event) => setPocketNameData(event.target.value.toUpperCase())}
        />
      ) : (
        <div className="dialog-content-text">
          <div style={{ lineHeight: '150%' }}>{t('createPocketModal.mainInstruction')}</div>
        </div>
      )}
    </Dialog>
  )
}
